import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: fit-content;
  margin: 0 auto; /* Center the container */
  padding: 20px 40px;
  background-color: #f4f7fb;
`;

export const DeviationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 40px; /* Adjusted gap to fit better */
  width: 100%; /* Ensure full width usage */
`;

export const LeftPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1); /* Soft shadow for a cleaner look */
  background-color: #ffffff;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15); /* Slight shadow on hover */
  }
`;

export const RightPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 15px;
  gap: 20px;
`;

export const ReferencePositionWrapper = styled.div`
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  background-color: #f9fafc;
  border: 1px solid #e1e4ea;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #007aff;
    box-shadow: 0 8px 20px rgba(0, 122, 255, 0.2);
  }
`;

export const InputTypeWrapper = styled.div`
  margin-bottom: 20px;
`;

export const RadioGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 20px;
`;

export const RadioButton = styled.label`
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  
  input {
    margin-right: 10px;
  }
`;

export const PositionInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  
  label {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 500;
  }
  
  input {
    padding: 12px;
    margin-bottom: 15px;
    font-size: 16px;
    border-radius: 6px;
    border: 1px solid #d1d5db;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: border-color 0.3s ease, box-shadow 0.3s ease;

    &:focus {
      border-color: #007aff;
      box-shadow: 0 0 8px rgba(0, 122, 255, 0.2);
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 15px;
`;

export const GridContainer = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const DeviationGrid = styled.div`
  position: relative;
  width: 500px;
  height: 500px;
  background-color: #f1f5f9;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  background-image:
    linear-gradient(to right, rgba(160, 160, 160, 0.2) 1px, transparent 1px),
    linear-gradient(to bottom, rgba(160, 160, 160, 0.2) 1px, transparent 1px);
  background-size: 50px 50px;
  margin-left: 40px;
  margin-top: 20px;
`;

export const ZoomSlider = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  margin-top: 30px;
  justify-content: center;
`;

export const ZoomButton = styled.button`
  background: linear-gradient(135deg, #6a9cf1, #4a7bd9); /* Gradient for a modern look */
  border: none;
  border-radius: 50%;
  color: #fff;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 1.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Soft shadow for depth */
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #4a7bd9, #2f5bb5); /* Darker on hover */
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3); /* Stronger shadow on hover */
    transform: scale(1.1); /* Slight zoom effect */
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 10px rgba(0, 122, 255, 0.8); /* Focus ring effect */
  }
`;

export const ZoomSliderInput = styled.input`
  width: 500px;
  height: 8px;
  appearance: none;
  background-color: #d9d9d9;
  border-radius: 10px;
  outline: none;
  transition: background-color 0.3s ease;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 20px;
    height: 20px;
    background-color: #007aff;
    border-radius: 50%;
    cursor: pointer;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.3);
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #005bb5;
    }
  }
`;

export const CentralDot = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #007aff;
  border-radius: 50%;
`;

export const PositionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  border-bottom: 1px solid #d9d9d9;
  padding: 10px 0;
  white-space: nowrap;
`;

export const Label = styled.div`
  font-weight: bold;
  font-size: 17px;
`;

export const Value = styled.div`
  font-size: ${({ strong }) => (strong ? '20px' : '16px')};
  font-weight: ${({ strong }) => (strong ? 'bold' : 'normal')};
  text-align: right;
  min-width: 220px;
  position: relative;
  bottom: 2px;
  white-space: nowrap;
`;

export const AxisLabelN = styled.div`
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  font-size: 20px;
  color: #007aff;
  opacity: 0.8;
`;

export const AxisLabelE = styled.div`
  position: absolute;
  right: -40px;
  left: 50%;
  transform: translateX(100%);
  font-weight: bold;
  font-size: 20px;
  color: #007aff;
  opacity: 0.8;
`;

export const SectionTitle = styled.h3`
  border-bottom: 2px solid #d1d5db;
  padding-bottom: 8px;
  margin-bottom: 25px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
`;

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px 18px;
  font-size: 15px;
  background-color: #007aff;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #005bb5;
  }
`;


export const StyledButtonAlt = styled(StyledButton)`
  background-color: #34c759;

  &:hover {
    background-color: #28a745;
  }
`;

export const CurrentPositionWrapper = styled.div`
  padding: 24px 34px 24px 24px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 25px;
  border: 1px solid #d1d5db;
  width: 380px;
`;

export const DeviationResultWrapper = styled.div`
  padding: 48px;
  background-color: #fafafa;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

export const FixedPositionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 320px;
  padding: 10px 0;
  font-family: 'Arial', sans-serif;
  border-bottom: 1px solid #ccc;
`;

export const Unit = styled.span`
  font-size: 13px;
  color: #666;
`;

// Example of missing styled-components
export const StyledLabel = styled.label`
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 10px;
  display: inline-block;
`;

export const StyledSelect = styled.select`
  width: 100%;
  padding: 12px;
  font-size: 1.1rem;
  border: 2px solid #ccc;
  border-radius: 6px;
  background-color: #fafafa;
  margin-bottom: 25px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);

  &:focus {
    border-color: #007aff;
    outline: none;
  }
`;

export const StyledOption = styled.option`
  font-size: 1rem;
  padding: 12px;
`;

export const CrossLineHorizontal = styled.div`
  position: absolute;
  height: 2px;
  width: 100%;
  background-color: #007aff;
`;

export const CrossLineVertical = styled.div`
  position: absolute;
  width: 2px;
  height: 100%;
  background-color: #007aff;
`;

export const DeviationPoint = styled.div`
  position: absolute;
  width: 2px;
  height: 2px;
  background-color: transparent; /* No background color */
  transform: translate(-50%, -50%);
  
  /* Create the cross shape */
  &::before, &::after {
    content: '';
    position: absolute;
    background-color: red;
  }

  /* Horizontal line */
  &::before {
    width: 12px;
    height: 2px; /* Thin line */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  /* Vertical line */
  &::after {
    width: 2px; /* Thin line */
    height: 12px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const ScaleLabel = styled.div`
  position: absolute;
  font-size: 12px;
  color: #000;
  transform: translate(-50%, -50%);
`;
